import {Card} from "../../../cdx-models/Card";
import {Query} from "../../../cdx-models/utils/MakeModel";
import {SearchCategory} from "../search-types";

const processSearchValue = (val: string) => {
  return {op: "search", value: val} as any as Query<Card>["content"];
};

const contentCategories: SearchCategory<string>[] = [
  {
    label: "Title",
    key: "cardTitle",
    getSuggestions({input}) {
      const m = input.match(/^\s*t:\s*(\S.*)/);
      if (m) {
        return [m[1]];
      } else {
        return [];
      }
    },
    valueToKey(title) {
      return title;
    },
    valuesToDbQuery(values, {forceOr}) {
      if (values.length === 1) return {title: {op: "contains", value: values[0]}};
      return {
        [forceOr ? "$or" : "$and"]: values.map((title) => ({
          title: {op: "contains", value: title},
        })),
      };
    },
    renderSuggestion(title) {
      return `contains '${title}'`;
    },
    savedSearchLabel(title) {
      return {
        prio: 1,
        label: `title '${title}'`,
      };
    },
  },
  {
    label: "Content",
    key: "content",
    getSuggestions({input}) {
      return [input];
    },
    valueToKey(content) {
      return content;
    },
    valuesToDbQuery(values, {forceOr}) {
      if (values.length === 1) return {content: processSearchValue(values[0])};
      const vals = values.map((content) => ({
        content: processSearchValue(content),
      }));
      return forceOr ? {$or: vals} : {$and: vals};
    },
    renderSuggestion(content) {
      return `contains '${content}'`;
    },
    savedSearchLabel(content) {
      return {
        prio: 1,
        label: `'${content}'`,
      };
    },
  },
];

export default contentCategories;
